import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-net-detail',
  templateUrl: './net-detail.component.html'
})
export class NetDetailComponent extends BaseComponent {
  @Input()
  netId:any;

  net:any;
  nes:any[];

  @Output()
  persisted:EventEmitter<any> = new EventEmitter<any>();

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              protected authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.http.get(`${this.env.e.url}/domain/nes/all`).subscribe(
      data => {
        this.nes = data as any[];
      }
    );
  }

  public ngOnInit(): void {
    if (this.netId) {
      this.load(this.netId);
    } else {
      this.route.params
        .subscribe((params: Params) => {
          let id:any = params['id'];
          if (id === '0') {
            this.createNew();
          } else {
            this.load(id);
          }
        });
    }
  }

  load(id:any) {
    this.http.get(`${this.env.e.url}/domain/nets/${id}`).subscribe(
      data => {
        this.net = data as any;
      }
    );
  }

  createNew() {
    this.net = {
      companyId: this.authService.getCompanyId(),
      nes: []
    };
  }

  save() {
    if (!this.net.id) {
      this.http.post(`${this.env.e.url}/domain/nets`, this.net)
        .subscribe(
          data => {
            this.net = data;
            this.alertService.info(`Created ${this.net.name}`);
            this.persisted.emit({
              data: data,
              action: 'added'
            });
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/domain/nets/${this.net.id}`, this.net)
        .subscribe(
          data => {
            this.net = data;
            this.alertService.info(`Updated Network Type Settings`);
            this.persisted.emit({
              data: data,
              action: 'updated'
            });
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/domain/nets/${this.net.id}`)
      .subscribe(
        complete => {
          this.persisted.emit({
            data: this.net,
            action: 'deleted'
          });
          this.alertService.info(`Deleted Network Type ${this.net.name}`);
          if (!this.netId) {
            this.router.navigate(["/nets"]);
          }
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
